import { render } from "./AccountEntry.vue?vue&type=template&id=3bb3a5ae&scoped=true"
import script from "./AccountEntry.vue?vue&type=script&lang=js"
export * from "./AccountEntry.vue?vue&type=script&lang=js"

import "./AccountEntry.vue?vue&type=style&index=0&id=3bb3a5ae&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb3a5ae"]])

export default __exports__